import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { ApplicationLanguages, VideoLanguages } from "../components/language/language";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root',
})
export class LanguageService {
    apiUrl = environment.apiUrl

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
    constructor(private authservice:AuthService,private http:HttpClient){}

    /** French video hosts (e.g. video.rse.acsm.ca) default UI to Canadian French when none saved. */
    applyHostDefaultLanguageIfNeeded(): void {
        if (localStorage.getItem('video-store-language')) {
            return;
        }
        if (this.isFrenchHost()) {
            this.setCurrentLang(VideoLanguages.CanadianFrench.toString());
        }
    }

    isFrenchHost(): boolean {
        const host = window.location.hostname.toLowerCase();
        return host === 'video.rse.acsm.ca'
            || host.endsWith('.rse.acsm.ca')
            || host === 'rse.acsm.ca';
    }

    setCurrentLang(lang:string)
    {
        localStorage.setItem('video-store-language', lang);
    }

    getCurretnLang():VideoLanguages
    {
        let currentlang = parseInt(localStorage.getItem('video-store-language')!) as VideoLanguages;
        return (currentlang == null || Number.isNaN(currentlang))? VideoLanguages.English:currentlang
    }

   
    getAllVideoLanguages():Observable<any[]>
   {    
    return this.http.get<any[]>(this.apiUrl+'videoStore/getAllVideoLanguages')
   }

    /**
     * Mirrors BB.Entities.Enums.VideoLanguage — used when the API is unreachable or returns no rows.
     */
    getFallbackVideoLanguages(): { id: number; description: string }[] {
        return [
            { id: VideoLanguages.English, description: 'English' },
            { id: VideoLanguages.French, description: 'Anglais avec doublage en Français' },
            { id: VideoLanguages.CanadianFrench, description: 'Français Canadien' },
            { id: VideoLanguages.Punjabi, description: 'ਪੰਜਾਬੀ' },
            { id: VideoLanguages.ChineseSimplified, description: '普通话' },
            { id: VideoLanguages.Arabic, description: 'عربى' },
            { id: VideoLanguages.Persian, description: 'فارسی' },
            { id: VideoLanguages.ChineseTraditional, description: '粵語' },
        ];
    }
}
